module.exports = __webpack_public_path__ + "assets/img/title-eeef2ade.png";